import { SchemaHelperController } from '../controller/SchemaHelperController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';

export class SchemaHelperWebComponent extends BaseWebComponentElement {
  public controller: SchemaHelperController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SchemaHelperController,
    });
  }
}
